import type WorkflowRunDocumentStageView from '@UI/Store/WorkflowRuns/Views/WorkflowRunDocumentStageView';

export type StageTone = 'active' | 'waiting' | 'running' | 'review' | 'failed' | 'verified';

/** The one tone of a stage, read from the server state of its documents: a failure wins, then a review. */
const resolveStageTone = (stage: WorkflowRunDocumentStageView): StageTone => {
	const states = stage.documents.map((document) => document.state.value);

	if (states.includes('failed')) {
		return 'failed';
	}

	if (states.includes('to_review')) {
		return 'review';
	}

	if (states.includes('running')) {
		return 'running';
	}

	if (states.length > 0 && states.every((state) => state === 'verified')) {
		return 'verified';
	}

	if (states.length > 0 && states.every((state) => state === 'waiting')) {
		return 'waiting';
	}

	return 'active';
};

export default resolveStageTone;
